"use client"

import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap/dist/js/bootstrap.bundle.min"

import "./App.css"

import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom"
import { AppProvider, useApp } from "./contexts/AppContext"
import ClasseurPage from "./pages/ClasseurPage"
import FeuillePage from "./pages/FeuillePage"
import FeuilleFieldPage from "./pages/FeuilleFieldPage"
import LandingPage from "./pages/LandingPage"
import LoginPage from "./pages/LoginPage"
import FeuilleDataPage from "./pages/FeuilleDataPage"
import NotFoundPage from "./pages/NotFoundPage"


// PrivateRoute component to protect routes
const PrivateRoute = ({ children }) => {
  const { user, loading } = useApp()

  if (loading) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Chargement...</span>
        </div>
      </div>
    )
  }

  return user ? children : <Navigate to="/login" />
}

function App() {
  return (
    <AppProvider>
      <Router>
        <div className="min-vh-100 bg-light rounded-1">
          <div className="container-fluid p-0 rounded-1 overflow-hidden">
            <Routes>
              {/* Public Routes */}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/" element={<LandingPage />} />
              <Route path="/projet/:projectId" element={<ClasseurPage />} />
              <Route path="/classeur/:classeurId" element={<FeuillePage />} />
              <Route path="/feuille/:feuilleId/fields" element={<FeuilleFieldPage />} />
              <Route path="/feuille/:feuilleId/data" element={<FeuilleDataPage />} />
              <Route path="/feuille/:feuilleId/data/:dataId" element={<FeuilleDataPage />} />
              <Route path="*" element={<NotFoundPage />} />

              {/* Private Routes */}
              <Route element={<PrivateRoute />}>
                {/* <Route path="/projet/:projectId" element={<ClasseurPage />} />
                <Route path="/classeur/:classeurId" element={<FeuillePage />} />
                <Route path="/feuille/:feuilleId/fields" element={<FeuilleFieldPage />} />
                <Route path="/feuille/:feuilleId/data" element={<FeuilleDataPage />} /> */}
              </Route>
            </Routes>
          </div>
        </div>
      </Router>
    </AppProvider>
  )
}

export default App
